


// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey:process.env.REACT_APP_apiKey,
//   authDomain:process.env.REACT_APP_authDomain,
//   projectId:process.env.REACT_APP_projectId,
//   storageBucket:process.env.REACT_APP_storageBucket,
//   messagingSenderId:process.env.REACT_APP_messagingSenderId,
//   appId:process.env.REACT_APP_appId,
//   measurementId:process.env.REACT_APP_measurementId,
// };

const firebaseConfig = {
  apiKey: "AIzaSyDkmt_RvhK3Jw_9wXRKEaGOetP0SnagYiA",
  authDomain: "independent-service-ebe40.firebaseapp.com",
  projectId: "independent-service-ebe40",
  storageBucket: "independent-service-ebe40.appspot.com",
  messagingSenderId: "301636717805",
  appId: "1:301636717805:web:4c40551fe2722b506050e4",
  measurementId: "G-EEZ5HF02X2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);

export default auth;

